module.exports = __webpack_public_path__ + "img/ref-4.4fa03bef.jpg";